import styled from 'styled-components'

const SocialButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 30px;
`

const SocialLoginView = styled.div`
  display: flex;
  flex-direction: column;
`

const SocialLoginTitle = styled.div`
  display: inline-block;
  text-align: center;
  margin-bottom: ${props => props.theme.social?.title?.marginBottom || '10px'};
  text-transform: ${props => props.theme.social?.title?.transform};
  color: ${props => props.theme.social?.title?.color || props.theme.font.color.dark};
  font-size: ${props => props.theme.social?.title?.fontSize || props.theme.font.size};
  line-height: ${props => props.theme.social?.title?.lineHeight};
  font-family: ${props => props.theme.social?.title?.fontFamily || props.theme.font.boldFamily};
  font-weight: ${props => props.theme.social?.title?.fontWeight || props.theme.font.boldFontWeight};
`

export {SocialButtonsContainer, SocialLoginView, SocialLoginTitle}
